/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Cta_StartInputs */

const tr_landing_hero_cta_start = /** @type {(inputs: Landing_Hero_Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlayın`)
};

const en_landing_hero_cta_start = /** @type {(inputs: Landing_Hero_Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get Started`)
};

const de_landing_hero_cta_start = /** @type {(inputs: Landing_Hero_Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt starten`)
};

const ru_landing_hero_cta_start = /** @type {(inputs: Landing_Hero_Cta_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать`)
};

/**
* | output |
* | --- |
* | "Get Started" |
*
* @param {Landing_Hero_Cta_StartInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_hero_cta_start = /** @type {((inputs?: Landing_Hero_Cta_StartInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Cta_StartInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_cta_start(inputs)
	if (locale === "de") return de_landing_hero_cta_start(inputs)
	if (locale === "ru") return ru_landing_hero_cta_start(inputs)
	return tr_landing_hero_cta_start(inputs)
});